import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const GET_WINNER_LIST_REQUEST = 'GET_WINNER_LIST_REQUEST';
export const GET_WINNER_LIST_SUCCESS = 'GET_WINNER_LIST_SUCCESS';
export const GET_WINNER_LIST_ERROR = 'GET_WINNER_LIST_ERROR';

export function getWinnerListRequestAction() {
	return { type: GET_WINNER_LIST_REQUEST };
}

export function getWinnerListSuccessAction(data) {
	return { type: GET_WINNER_LIST_SUCCESS, data };
}

export function getWinnerListErrorAction(error) {
	return { type: GET_WINNER_LIST_ERROR, error };
}

export function fetchWinnerListAction() {
	return dispatch => {
		dispatch(getWinnerListRequestAction());

		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/game/winners`
			})
		).then(
			json => dispatch(getWinnerListSuccessAction({ data: json['RESPONSE'] })),
			err => {
				dispatch(getWinnerListErrorAction(err));
			}
		);
	};
}
